import type { FaireProductEntity } from "../../entity_types/product";

export const p_e6nbry9s6y: FaireProductEntity = {
  token: "p_e6nbry9s6y",
  type: "product",
  name: "Cotton Leila Cardigan (2XS/S - 2M/L)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/bb1e31eab32b202669caa259ff8e78192109768fb51c48587214127b670c7801.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8c31d26a4fd6b109676c98f954a22d64f4d8f8f1c37769f91846336ae5353b4c.jpeg",
    "https://cdn.faire.com/fastly/a4092df989ff3903313156727bb19fb9c17e93d9d57d123e36d765defc92dee6.jpeg",
    "https://cdn.faire.com/fastly/cc0998764ced845333113b3ac5224c53aa30ab95edcb71ba9bcf92f8f5a35817.jpeg",
    "https://cdn.faire.com/fastly/18cd17e9a1cb5a31e1d2e9ec0039093f4a036042bcb0cfaef58df2a5509efe15.jpeg",
    "https://cdn.faire.com/fastly/b7239401f30413a217de7450bbae67c29e1d23a284602b10db9c2b042bf8505f.jpeg",
    "https://cdn.faire.com/fastly/b7f7fe47dcebb834490a762497dac8b9c07680e0e1744bbeda262a1133fdb129.jpeg",
    "https://cdn.faire.com/fastly/c5d634b13a39518eca4e8f3ceeec2364231e8c2cfc18815b29ff6be25c45f067.jpeg",
    "https://cdn.faire.com/fastly/fadbf51e5dc0a71682d2e8155f1b15190b66c3fdf6bbe26b99397fe6546b49de.jpeg",
    "https://cdn.faire.com/fastly/44d65eaa500fbd18c4fd0abbfb8b0d5cdeef6b0b76d7871011d00a831f1492ce.jpeg",
    "https://cdn.faire.com/fastly/7c08cda46fb8cf84ababfc2c7edff73942674f610853bbb2d08b1983f72109ea.jpeg",
    "https://cdn.faire.com/fastly/64809691b9b8582a815356789e706e2d7cd13479de02bd3ae3df22cb6886e947.jpeg",
    "https://cdn.faire.com/fastly/9a823ca338a2355f67991686b655d82f0863004aa117737f1774c1b439a85285.jpeg",
    "https://cdn.faire.com/fastly/946d12d55e0c67db1518c092a4a50b578c449057d7c7d028888da1392a44e319.jpeg",
    "https://cdn.faire.com/fastly/9ec021c82316b82224681546c42ec515cc4802425527bf1320e4d092f58b4088.jpeg",
    "https://cdn.faire.com/fastly/2fcd2aaea97d7ea159a41e7a7305ba675150b779a44f1bd67871a70438776249.jpeg",
    "https://cdn.faire.com/fastly/0b3fcf5b4c25b7239728458818922f1ff44125590be274a22ed5d2890dae4388.jpeg",
    "https://cdn.faire.com/fastly/5e560806fc6fd4f9cb4ffd7b60f6d8864d25f0f70dfe59183e38001d62addd50.jpeg",
    "https://cdn.faire.com/fastly/f353adc5cd6faea833d72ed9b9addc813c64681056fc89143abe598502d30609.jpeg",
    "https://cdn.faire.com/fastly/fd8252b95dd3d328469773dba4e530029ae1603e5e36ad335b2c6ed2baf49557.jpeg",
    "https://cdn.faire.com/fastly/1fc03f79a19ca7ce2c13545b7cb7a7f37c7d2af0024e53519f215b445cd953cf.jpeg",
    "https://cdn.faire.com/fastly/1ee4697e08fee13e4ff5fb70cb9e03a26bf1cae83afb3a02dd0f656e33d39366.jpeg",
    "https://cdn.faire.com/fastly/7c13fef96a5a47caf113c53504b5dd2163c75112862695cc40db6c7278f06934.jpeg",
    "https://cdn.faire.com/fastly/3297c32402ac02b0594fd08dc761cb1a1f5c19ccfede69a4079d61f12bc0745c.jpeg",
  ],
  priceDollars: 280,
  description:
    '𝐖𝐡𝐲 𝐰𝐞 𝐦𝐚𝐝𝐞 𝐭𝐡𝐢𝐬?\n\nThe perfect cross between our Leila Mohair Cardigan and Milo Cotton Sweater, the Leila Cotton Cardigan blends familiar fit and design details from the mohair version with the ease of a cotton knit. It features a relaxed silhouette with a standard length, finished with authentic shell buttons for an elevated touch. Lightweight and airy, this cotton sweater layers effortlessly up or down. Wear it over a tee and pants or draped over the shoulders with a dress.\n\n\n𝐂𝐨𝐧𝐭𝐞𝐧𝐭𝐬:\n\n• 100% Cotton\n\n• Made in South Korea\n\n\n𝐂𝐚𝐫𝐞 𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\n\n• Hand wash in cold water\n\n• Towel dry & lay flat to dry\n\n\n𝐀𝐩𝐩𝐫𝐨𝐱𝐢𝐦𝐚𝐭𝐞 𝐌𝐞𝐚𝐬𝐮𝐫𝐞𝐦𝐞𝐧𝐭𝐬:\n\n• XS/S: Length 21", Chest 21 1/2"\n\n• M/L: Length: 21 1/2", Chest: 23" \n\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip: 36" and wearing a size XS/S \n\n\nMSRP: $140 USD',
  tags: [],
  msrpDollars: 560,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:51:55.806Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
